// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__JkSAQ","row":"ProcedureTreatmentSummary_row__a1drV"};